import React from 'react';
import UtilImage from '../utils/util-image'

export default function ContentBasicImage(props) {
  //console.log('ContentBasicImage - props', props);

  const {
    displayText,
    centered,
    rounded,
    circular,
    verticalAlign,
    size,
    image
  } = props;

  //const textColor = props.text_color ? props.text_color : props.header_text_color ? props.header_text_color : null;
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      <div className={'site-content-basic-image'+(centered ? ' centered' : '')}>
        {image && image.imageAbsoluteUrls.length !== 0 ?
          <UtilImage altText={(displayText ? displayText : '') +' image'} image={image}
            semanticProps={{
              centered,
              rounded,
              circular,
              verticalAlign,
              size,
            }}
          />
        :
          null
        }
      </div>
    </>
  )
}
